import React from 'react';
import './FooterPage.css';

const Impressum = () => {
  return (
    <div className="footer-page">
        <div className="footer-page__container">
        <h1>Impressum</h1>
        
        <section>
          <h3>ANGABEN GEMÄSS § 5 TMG</h3>
          <p>Rugby Deutschland e.V.</p>
          <p>Geschäftsstelle</p>
          <p>Im Neuenheimer Feld 710</p>
          <p>69120 Heidelberg</p>
        </section>
        
        <section>
          <h3>VERTRETEN DURCH:</h3>
          <p>Werner Cromm – Vorstand</p>
          <p>Florian Hartmann - Vorstand Struktur & Entwicklung</p>
        </section>
        
        <section>
          <h3>KONTAKT:</h3>
          <p>Telefon: +49 (0) 6221 35 211 0</p>
          <p>E-Mail: office@rugbydeutschland.org</p>
        </section>
        
        <section>
          <h3>REGISTEREINTRAG:</h3>
          <p>Eintragung im Vereinsregister</p>
          <p>Registergericht: Hannover</p>
          <p>Registernummer: VR2089</p>
        </section>
        
        <section>
          <h3>UMSATZSTEUER:</h3>
          <p>Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz:</p>
          <p>DE115666117</p>
        </section>
        
        <section>
          <h3>VERANTWORTLICH FÜR DEN INHALT NACH § 55 ABS. 2 RSTV:</h3>
          <p>ViSdP (auch für die offiziellen Auftritte des DRV auf Facebook, Twitter, Instagram und YouTube):</p>
          <p>Vorstand des DRV</p>
          <p>Autoren:</p>
          <p>Jens Beeskow (jb)</p>
          <p>Jens Köhler (jk)</p>
        </section>
        
        <section>
          <h3>STREITSCHLICHTUNG</h3>
          <p>Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:</p>
          <p><a href="https://ec.europa.eu/consumers/odr">https://ec.europa.eu/consumers/odr</a></p>
          <p>Unsere E-Mail-Adresse finden Sie oben im Impressum.</p>
          <p>Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p>
        </section>
        
        <section>
          <h3>HAFTUNG FÜR INHALTE</h3>
          <p>Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.</p>
          <p>Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.</p>
        </section>
        
        <section>
          <h3>HAFTUNG FÜR LINKS</h3>
          <p>Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.</p>
          <p>Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.</p>
        </section>
        
        <section>
          <h3>URHEBERRECHT</h3>
          <p>Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.</p>
          <p>Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.</p>
        </section>

        <h1>Betreiber der Webseite</h1>
        <section>
          <h3>ANGABEN GEMÄSS § 5 TMG</h3>
          <p>Kether OS GmbH</p>
          </section>
          <section>
          <h3>Geschäftsstelle</h3>
          <p>Kniephofstraße 3</p>
          <p>12157 Berlin</p>
        </section>
        
        <section>
          <h3>VERTRETEN DURCH:</h3>
          <p>Marvin Nitschke - CEO</p>
          <p>Lukas Hillbricht - CTO</p>
        </section>
        
        <section>
          <h3>KONTAKT:</h3>
          <p>E-Mail: <a href="mailto:contact@ketheros.com">contact@ketheros.com</a></p>
        </section>
        
        <section>
          <h3>REGISTEREINTRAG:</h3>
          <p>Eintragung im Amtsgericht</p>
          <p>Registergericht: Charlottenburg, Berlin</p>
          <p>Registernummer: HRB277216B</p>
        </section>      
      </div>
    </div>
  );
};

export default Impressum;
